import styled, { css } from 'styled-components/macro';
import { VARIABLES } from 'styles/globals';

export const StyledLayerSettingsComponent = styled.div``;
